import { render, staticRenderFns } from "./StudentsWithPhoto.vue?vue&type=template&id=0fc9857c&"
import script from "./StudentsWithPhoto.vue?vue&type=script&lang=js&"
export * from "./StudentsWithPhoto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports